import cliente from './cliente'
import estado from './estado'
import municipio from './municipio'
import pais from './pais'

export default baseUrl => {
    baseUrl = `${baseUrl}/comum`

    return {
        cliente: cliente(baseUrl),
        estado: estado(baseUrl),
        municipio: municipio(baseUrl),
        pais: pais(baseUrl),
    }
}